// extracted by mini-css-extract-plugin
module.exports = {"link":"EmptyGrowthMessage_link__fOjrp"};